export default "__VITE_ASSET__BgZT1G15__"